import { render } from "./SportsStorePage.vue?vue&type=template&id=c89a7f0e"
import script from "./SportsStorePage.vue?vue&type=script&lang=js"
export * from "./SportsStorePage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__